<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <span class="text-h5 font-weight-bold ml-3 full-width page-header">{{
        $t("menu.admin")
      }}</span>
      <v-spacer></v-spacer>
      <v-tabs
        class="a-tabs pt-3 tab-align-lang-style"
        v-model="selectedTab"
        show-arrows
        height="38"
        style="background-color: var(--v-Neutral-base)"
        right
        @change="onTabChange"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab class="roles">
          <v-icon left>mdi-text-account</v-icon>{{ $t("admin.userRoles") }}
        </v-tab>

        <v-tab class="users">
          <v-icon left>mdi-account-supervisor</v-icon>{{ $t("admin.users") }}
        </v-tab>
        <v-tab class="settings">
          <v-icon left>mdi-cog-outline</v-icon>{{ $t("menu.settings") }}
        </v-tab>
      </v-tabs>
    </template>
    <template v-slot:page-content>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-tabs-items v-model="currentTab">
            <v-tab-item>
              <RoleManagement></RoleManagement>
            </v-tab-item>
            <v-tab-item>
              <UserManagement></UserManagement>
            </v-tab-item>
            <v-tab-item>
              <List
                :is-change-prevent.sync="isDirty"
                :isOpenPrevent="isPrevent"
                @discard="onDiscard"
                @save="onSave"
                @cancel="onCancel"
              ></List>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </template>
  </page-container>
</template>

<script>
import RoleManagement from "@/components/admin/RoleManagement.vue";
import UserManagement from "@/components/admin/UserManagement.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { permissions } from "../../utils/constant";
import { createUUID } from "../../utils/util";
import List from "@/components/settings/list.vue";
import Loader from "@/components/Loader.vue";
import SignalRMixin from "../../mixin/SignalRMixin";

export default {
  name: "AdminSettings",
  mixins: [SignalRMixin],
  data() {
    return {
      selectedTab: 0,
      currentTab: 0,
      isDirty: false,
      isPrevent: false,
      navigateTab: 0,
    };
  },
  components: {
    RoleManagement,
    UserManagement,
    List,
    Loader,
  },
  computed: {
    ...gettersMap(),
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
  },
  created() {},
  async mounted() {
    try {
      await this.getMasterConfigList();
      await this.getRoleList();
      await this.getUserList();
      await this.signalRInit();
    } catch (error) {
      console.log(error, "admin");
    }
  },
  methods: {
    ...mapActions({
      createTenantConfig: "tenant/createTenantConfig",
      getMasterConfigList: "tenant/getMasterConfigList",
      getUserList: "admin/getUserList",
      getRoleList: "admin/getRoleList",
      getUpdatedUserList: "people/getUpdatedUserList",
    }),
    setUpTenantConfigList,
    onTabChange,
    onDiscard,
    onSave,
    onCancel,
    async signalRInit() {
      let target = `admin_${this.selectedTenant}`;
      this.signalConnection.on(target, async (message) => {
        const result = JSON.parse(message);
        if (result) {
          try {
            await this.getRoleList();
            await this.getUserList();
            await this.getUpdatedUserList();
          } catch (error) {
            console.log(error, "API error");
          }
        }
      });
      if (
        this.signalConnection.connectionState.toLowerCase() === "disconnected"
      ) {
        this.signalConnection.start().catch();
      }
    },
  },
};

function onCancel() {
  this.isPrevent = false;
}

function onSave() {
  this.isPrevent = false;
  this.selectedTab = this.navigateTab;
  this.currentTab = this.navigateTab;
}

function onDiscard() {
  this.isPrevent = false;
  this.selectedTab = this.navigateTab;
  this.currentTab = this.navigateTab;
}

function onTabChange() {
  if (this.isDirty) {
    this.$nextTick(() => {
      this.navigateTab = this.selectedTab;
      this.selectedTab = this.currentTab;
      this.isPrevent = true;
    });
    return;
  }
  this.currentTab = this.selectedTab;
}

async function setUpTenantConfigList() {
  const tenantPermissions = this.masterSettingTypes("permissions");
  if (!tenantPermissions) {
    const permissionsObj = {
      id: createUUID(),
      tenantid: this.selectedTenant,
      configname: "permissions",
      permissions: permissions,
    };
    this.createTenantConfig(permissionsObj);
  }
}

function gettersMap() {
  return mapGetters({
    tenantSettingConfig: "tenant/tenantSettingConfig",
    tenantSettingTypes: "tenant/tenantSettingTypes",
    masterSettingConfig: "tenant/masterSettingConfig",
    masterSettingTypes: "tenant/masterSettingTypes",
  });
}
</script>
<style scoped>
::v-deep .theme--dark.v-tabs > .v-tabs-bar {
  /* background-color: #1E1E1E; */
  background: transparent !important;
}
.tab-align-lang-style .v-tab.roles {
  width: 128px;
}
.tab-align-lang-style .v-tab.users {
  width: 128px;
}
.tab-align-lang-style .v-tab.settings {
  width: 140px;
}
.a-tabs .v-tab--active {
  background: #dde3ee;
}
</style>